let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9Fn3W"), load("5CaYW"), load("7niKq")]).then(() => parcelRequire('2O6Yo'));